module.exports = __webpack_public_path__ + "img/window-4.8d66c5e1.jpg";